import React from 'react';
import * as Mui from '@mui/material';
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RootState } from 'redux/store';
import { styles } from './styles.legacy';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Avatar } from "component/shared/avatar";
import { Agent } from 'model/agent';
import { AppCard } from "component/shared/app-card";
interface Props extends OwnProps,
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	WithStyles<typeof styles> {
	theme: Mui.Theme;
}

interface OwnProps {
	agent: Agent;
	position: number;
	onDelete: () => void;
}

interface State {
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
	return {
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators({
	}, dispatch);
};

class Component extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
		};
	}

	render() {
		const { classes = {}, position, agent, onDelete, theme } = this.props;
		return (
			<AppCard>	
				<Mui.Tooltip title={agent.enableAgentLink ? "" : "This agent will not appear in the agent list because ‘Enable Link on Agent Roster’ is turned off"}>																		
					<Mui.CardContent className={agent.enableAgentLink ? classes.cardContent : classes.greyCardContent}>
						<Mui.Grid container direction="row" spacing={1} alignItems="center">
							<Mui.Grid item>
								<DragIndicatorIcon />
							</Mui.Grid>
							<Mui.Grid item>
								<Mui.Box display="flex" alignItems="center" flexDirection="row">
									<Avatar 
										phrase={agent.label} 
										src={agent.photoUrl}
										color={theme.palette.primary.main}
									/>
									<Mui.Typography className={classes.agentLabel} >
										{agent.label}
									</Mui.Typography>
								</Mui.Box>
							</Mui.Grid>
							<Mui.Grid item className={classes.positionItem}>
								<Mui.Chip label={position} size="small" className={classes.position} />
							</Mui.Grid>
						</Mui.Grid>
					</Mui.CardContent>
				</Mui.Tooltip>
			</AppCard>
		);
	}
}

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(Component);

// tss-react's withStyles does not inject a `theme` prop the way the old JSS bridge's
// `{ withTheme: true }` did; this class component reads `theme.palette` in render, so inject it via useTheme.
const ThemedComponent = (props: OwnProps & WithStyles<typeof styles>) => {
	const theme = Mui.useTheme();
	return <ConnectedComponent {...props} theme={theme} />;
};

export const CardLegacy = withStyles(ThemedComponent, styles);